import React from 'react';
import { Cta } from './Cta';
import { Reveal } from './Reveal';
import { useScore } from './ScoreContext';
export function Hero() {
  const {
    answeredCount,
    openDiagnostic
  } = useScore();
  const ctaLabel = answeredCount === 0 ? 'Get Your Reader-to-Revenue Score' : answeredCount < 4 ? 'Continue Your Score' : 'Finish Your Score';
  const handleStartScore = () => {
    if (answeredCount === 0) {
      document.getElementById('quick-check-1')?.scrollIntoView({
        behavior: 'smooth'
      });
      return;
    }
    openDiagnostic();
  };
  return <section className="relative px-6 pt-14 pb-20 md:pt-16 md:pb-24" data-id="element-200">
      <div className="relative max-w-[1040px] mx-auto" data-id="element-201">
        {/* Centered eyebrow pill */}
        <Reveal data-id="element-202">
          <div className="flex justify-center" data-id="element-203">
            <span className="inline-block px-4 py-1.5 bg-white border border-black/[0.08] rounded-full text-sm text-navy/80 shadow-sm" data-id="element-204">
              For expert-authors whose book is already in the world
            </span>
          </div>
        </Reveal>

        {/* Centered top validation */}
        <Reveal delay={0.05} data-id="element-205">
          <h1 className="mt-6 text-center font-serif leading-[1.1] tracking-[-0.01em] text-[clamp(2.1rem,4vw,3.25rem)]" data-id="element-206">
            <span className="block text-seaglass" data-id="element-207">
              Your book did what a book can do.
            </span>
            <span className="block text-navy italic" data-id="element-208">
              It created authority.
            </span>
          </h1>
        </Reveal>

        {/* Lower tension composition: question left, artwork anchored to the hero's right edge */}
        <Reveal delay={0.1} data-id="element-209">
          <div className="mt-11 grid grid-cols-1 items-center gap-7 lg:mt-14 lg:grid-cols-[440px_1fr] lg:gap-x-12" data-id="element-210">
            <div className="order-1 lg:translate-x-16" data-id="element-211">
              <h2 className="font-serif text-sand-dark leading-[0.98] tracking-[-0.018em] text-center text-[clamp(2rem,8vw,2.75rem)] lg:text-left lg:text-[clamp(2.35rem,4.2vw,3.5rem)]" data-id="element-212">
                <span className="block lg:whitespace-nowrap" data-id="element-213">
                  But did it lead
                </span>
                <span className="block lg:whitespace-nowrap" data-id="element-214">
                  to the opportunities
                </span>
                <span className="block lg:whitespace-nowrap" data-id="element-215">
                  you expected?
                </span>
              </h2>
            </div>

            <div className="order-2 flex justify-center lg:justify-end" data-id="element-216">
              <img src="https://cdn.magicpatterns.com/uploads/2Kf51Az6vWVnbgm9K1c65M/Untitled_design_(6).png" alt="An open book whose pages flow into a winding sea-glass path toward a warmly glowing doorway — the path from a book to real opportunities." className="h-auto w-full max-w-[390px] object-contain lg:w-[480px] lg:max-w-none" loading="eager" data-id="element-217" />
            </div>
          </div>
        </Reveal>

        {/* Centered short body copy */}
        <Reveal delay={0.15} data-id="element-218">
          <div className="mt-9 md:mt-10 max-w-[620px] mx-auto text-center" data-id="element-219">
            <p className="text-navy font-semibold text-lg mb-2" data-id="element-220">
              Most readers disappear after the book.
            </p>
            <p className="text-lg text-text-muted leading-relaxed" data-id="element-221">
              You do not know who cared, what landed, what they needed next, or
              whether they were a fit for the work behind the book.
            </p>

            {/* Centered CTA */}
            <div className="mt-8 flex flex-col items-center" data-id="element-222">
              <Cta variant="primary" onClick={handleStartScore} className="min-h-[56px] px-8 py-4 font-semibold text-lg text-white opacity-100 w-full sm:w-auto" data-id="element-223">
                {ctaLabel}
              </Cta>
              <p className="mt-4 text-sm text-navy/80 font-medium" data-id="element-224">
                8 questions. See what happens after someone reads your book.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}